export default __webpack_public_path__ + "static/media/mockup-step-3-1.f5bbd290.png";